import axios from "axios";

const runtimeUrl = typeof window !== "undefined" && window.__ENV__ ? window.__ENV__.API_URL : undefined;

const baseURL =
  runtimeUrl ||
  process.env.REACT_APP_API_URL || // dev local
  "/api";                          // prod (proxy do Nginx)

console.log("API baseURL ->", baseURL);

const axiosInstance = axios.create({
  baseURL,
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export default axiosInstance;
